import $ from 'jquery';
import StateManager from '../scuba/StateManager';

/* -------------------------
    INIT
------------------------- */

$(window).on(StateManager.CONTENT_READY, function(event, node) {
    var background = $(node).data('background');
    if(background){
      var image = new Image();
      image.onload = function(){
        $("body").css("backgroundImage", `url(${background})`);
      }
      image.src = background;
    }
});


// WEBPACK FOOTER //
// ./scripts/components/Background.js